import React from "react";
import HeroSection from "../components/HeroSection";
import i18n from 'i18next';
import ProjectSection from "../components/ProjectSection";
import { projectObj1, projectObj2, projectObj3, projectObj4, projectObj5, projectObj6, projectObj1fr, projectObj2fr, projectObj3fr, projectObj4fr, projectObj5fr, projectObj6fr } from "../components/ProjectSection/data";
import TeamSection from "../components/TeamSection/team";


const HomePage = () => {
  const lang = i18n.language;

  return (
    <>
      <HeroSection />
      {lang === "fr" || lang === "fr-FR" ? 
      <>
      <ProjectSection {...projectObj1fr} />
      <ProjectSection {...projectObj2fr} />
      <ProjectSection {...projectObj3fr} />
      <ProjectSection {...projectObj4fr} />
      <ProjectSection {...projectObj5fr} />
      <ProjectSection {...projectObj6fr} />
      <div className="illustrations">
      Illustrations par <a href="https://icons8.com/illustrations/author/eEbrZFlkyZbD">Anna Antipina</a> et{" "}
        <a href="https://icons8.com/illustrations/author/u7l2K4BCiAa9">Natasha Remarchuk</a> de <a href="https://icons8.com/illustrations">Ouch!</a>
      </div>
      </>
      : 
      <>
      <ProjectSection {...projectObj1} />
      <ProjectSection {...projectObj2} />
      <ProjectSection {...projectObj3} />
      <ProjectSection {...projectObj4} />
      <ProjectSection {...projectObj5} />
      <ProjectSection {...projectObj6} />
      <div className="illustrations">
        Illustrations by <a href="https://icons8.com/illustrations/author/eEbrZFlkyZbD">Anna Antipina</a> and{" "}
        <a href="https://icons8.com/illustrations/author/u7l2K4BCiAa9">Natasha Remarchuk</a> from <a href="https://icons8.com/illustrations">Ouch!</a>
      </div>
      </>
      
      }
       <TeamSection />
    </>
  );
};

export default HomePage;
